const images = [
  {
    thumb: require("../../../assets/collection/aulic/antyk_i_jasny.jpg"),
    src: require("../../../assets/collection/aulic/antyk_i_jasny.jpg"),
    caption: "Antyk i Jasny",
    srcset: require("../../../assets/collection/aulic/antyk_i_jasny.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/antyk_i_opal.jpg"),
    src: require("../../../assets/collection/aulic/antyk_i_opal.jpg"),
    caption: "Antyk i Opal",
    srcset: require("../../../assets/collection/aulic/antyk_i_opal.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/dab_dolce.jpg"),
    src: require("../../../assets/collection/aulic/dab_dolce.jpg"),
    caption: "Dąb Dolce",
    srcset: require("../../../assets/collection/aulic/dab_dolce.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/dab_dworski.jpg"),
    src: require("../../../assets/collection/aulic/dab_dworski.jpg"),
    caption: "Dąb Dworski",
    srcset: require("../../../assets/collection/aulic/dab_dworski.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/dab_felice.jpg"),
    src: require("../../../assets/collection/aulic/dab_felice.jpg"),
    caption: "Dąb Felice",
    srcset: require("../../../assets/collection/aulic/dab_felice.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/dab_fernite.jpg"),
    src: require("../../../assets/collection/aulic/dab_fernite.jpg"),
    caption: "Dąb Fernite",
    srcset: require("../../../assets/collection/aulic/dab_fernite.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/dab_sedziwy.jpg"),
    src: require("../../../assets/collection/aulic/dab_sedziwy.jpg"),
    caption: "Dąb Sędziwy",
    srcset: require("../../../assets/collection/aulic/dab_sedziwy.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/dab_sedziwy_bis.jpg"),
    src: require("../../../assets/collection/aulic/dab_sedziwy_bis.jpg"),
    caption: "Dąb Sędziwy Bis",
    srcset: require("../../../assets/collection/aulic/dab_sedziwy_bis.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/dworska_opal.jpg"),
    src: require("../../../assets/collection/aulic/dworska_opal.jpg"),
    caption: "Dworska Opal",
    srcset: require("../../../assets/collection/aulic/dworska_opal.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/felice.jpg"),
    src: require("../../../assets/collection/aulic/felice.jpg"),
    caption: "Felice",
    srcset: require("../../../assets/collection/aulic/felice.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/secretariat.jpg"),
    src: require("../../../assets/collection/aulic/secretariat.jpg"),
    caption: "Secretariat",
    srcset: require("../../../assets/collection/aulic/secretariat.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/sedziwy.jpg"),
    src: require("../../../assets/collection/aulic/sedziwy.jpg"),
    caption: "Sędziwy",
    srcset: require("../../../assets/collection/aulic/sedziwy.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/aulic/dab_dworski_braz.jpg"),
    src: require("../../../assets/collection/aulic/dab_dworski_braz.jpg"),
    caption: "Dąb dworski brąz",
    srcset: require("../../../assets/collection/aulic/dab_dworski_braz.jpg"),
    description: ""
  }
];

export default images;
